import { render, staticRenderFns } from "./reviewReminder.vue?vue&type=template&id=e524e45c&"
import script from "./reviewReminder.vue?vue&type=script&lang=js&"
export * from "./reviewReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports